import PeoplePage from "@ProjectUsers/Pages/PeoplePage.vue";

export const routes = [
    {
        path: "/portfolio/people/:workspaceId/:projectId",
        component: PeoplePage,
    },
    {
        path: "/decision/people/:workspaceId/:projectId",
        component: PeoplePage,
    },
]
